<template>
  <div class="text-center">
    <v-bottom-sheet
      v-model="sheet"
      hide-overlay
      :no-click-animation="true"
      persistent
      :retain-focus="false"
    >
      <v-sheet
        style="background: rgba(0,0,0,0.9);"
      >
        <v-btn class="mr-md-6 mt-3" fab outlined dark absolute right width="30" height="30" color="#fff" @click="submit(true)">
          <v-icon color="#fff" size="20">fal fa-xmark</v-icon>
        </v-btn>
        <v-row no-gutters class="modelCookie pt-4 pb-6" justify="center">
          <v-col cols="12" class="modelCookie__content col-md-8 px-4 pt-md-0 pt-8">
            <div class="text-justify white--text" style="font-size: 0.875rem;">
              <translate>By continuing to browse this site, you accept the use of cookies for the operation of sharing buttons on social networks and for measuring the audience of the pages of the site. To better understand our privacy policy,</translate>
              <router-link class="ml-2" :to="{ name: 'rgpd' }" v-translate>RGPD</router-link>.
            </div>
            <v-row no-gutters class="modelCookie__action mt-4">
              <v-col>
                <v-btn
                  outlined
                  large
                  left
                  height="34"
                  width="180"
                  color="#fff"
                  class="px-5 font-weight-bold mr-4 btn__custom my-1"
                  @click="submit(true)"
                >
                  <v-icon color="#fff" size="20" class="mr-3">fal fa-check</v-icon>
                  <translate>Accept</translate>
                </v-btn>
                <v-btn
                  outlined
                  large
                  color="#fff"
                  class="px-5 font-weight-bold btn__custom mr-4 my-1"
                  @click="submit(false)"
                  height="34"
                  width="180"
                >
                  <v-icon color="#fff" size="20" class="mr-3">fal fa-xmark</v-icon>
                  <translate>REFUSE ALL</translate>
                </v-btn>
                <!-- <v-btn
                  outlined
                  large
                  color="#fff"
                  height="34"
                  class="px-5 font-weight-bold btn__custom"
                  @click="isParams = !isParams"
                >
                  <v-icon color="#fff" size="20" class="mr-3">fal fa-gear</v-icon>
                  <translate>SETTING</translate>
                  <v-icon color="#fff" size="20" class="ml-2">fal fa-arrow-right-long</v-icon>
                </v-btn> -->
              </v-col>
            </v-row>
            <!-- <v-expand-transition>
              <v-row no-gutters align="baseline" v-show="isParams" transition="slide-x-transition">
                <v-btn
                  outlined
                  large
                  color="#fff"
                  class="px-5 font-weight-bold btn__custom mr-4"
                  @click="submit(false)"
                  height="34"
                  width="160"
                >
                  <v-icon color="#fff" size="20" class="mr-3">fal fa-xmark</v-icon>
                  <translate>REFUSE ALL</translate>
                </v-btn>
                <v-switch
                  key="2"
                  v-model="switchBtn"
                  label="Google Analytics Tracking"
                  style="color: #fff"
                ></v-switch>
              </v-row>
            </v-expand-transition> -->
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: "CookiesModal",
  data() {
    return {
      sheet: true,
      switchBtn: 2,
      isParams: false,
      cookieData: {
        status: false,
        time: new Date(),
      }
    }
  },
  mounted() {},
  computed: {},
  methods: {
    submit(type) {
      if(type) {
        this.cookieData.status = 200
        this.setCookie()
      } else {
        this.sheet = !this.sheet
      }
    },
    setCookie() {
      localStorage.setItem('cookieData', JSON.stringify(this.cookieData))
      this.sheet = !this.sheet
    }
  }
};
</script>
